import React, { useState } from 'react';
import { ActionButtons } from './ActionButtons';
import { Header } from './Header';
import { PresetsList } from './PresetsList';

export const PresetsContainer = ({ presets, config }) => {
    const [selected, setSelected] = useState(null);
    const onSelection = (presetTransformation) => setSelected((transformation) => transformation === presetTransformation ? '' : presetTransformation);
    const { cloudName, assets } = config || {};
    const [displayAsset] = assets || [];
    const loading = !config || !presets;

    return (
        <>
            <Header assets={assets}/>
            <PresetsList
                presets={presets}
                loading={loading}
                displayAsset={displayAsset}
                onSelection={onSelection}
                selected={selected}
                cloudName={cloudName}
            />
            <ActionButtons
                selectedPreset={selected}
                assets={assets}
                cloudName={cloudName}
            />
        </>
    );
};
